import { render, staticRenderFns } from "./Unfinished.vue?vue&type=template&id=7d68590b&scoped=true"
import script from "./Unfinished.vue?vue&type=script&lang=js"
export * from "./Unfinished.vue?vue&type=script&lang=js"
import style1 from "./Unfinished.vue?vue&type=style&index=1&id=7d68590b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d68590b",
  null
  
)

export default component.exports